<template>
	<Disclosure :title="$t('text.businessHours')" :error="sectionMessage.error" :message="sectionMessage.message" :lock="!userMayEditFields || contentManagedByMyCity" data-cy="businessInfo" ref="SECTION_businessInfo">
		<p class="subTitle" v-if="app === 'BusinessProfile'" v-html="$t('text.businessProfileInfoDesc')"/>
		<p class="subTitle" v-if="app === 'ServiceDesigner'" v-html="$t('text.serviceDesignerInfoDesc')"/>

		<div class="field left-border">
			<div v-if="app === 'BusinessProfile'">
				<v-label>{{ $t('text.averageDurationOfStayInMinutes') }}</v-label>
				<v-text-field
					variant="outlined" density="compact" hide-details v-mask="'####'"
					v-model="averageDurationOfStayInMinutesLocal"
					style="width: 15%;"
					@update:modelValue="$emit('average-duration-changed', averageDurationOfStayInMinutesLocal)"
				/>
				<p class="helpText" v-html="$t('text.averageDurationOfStayInMinutesDesc')" style="margin-left:0px"/>
			</div>
			<p class="subTitle" v-html="$t('text.businessHours')" style="margin-top: 10px;" />
			<p class="helpText" v-if="!showCopyOption" v-html="$t('text.businessHoursHelp')"/>
			<p class="helpText" v-if="showCopyOption" v-html="$t('text.businessHoursServiceHelp')"/>

			<div v-if="showCopyOption">
				<v-radio-group v-model="copyOption" col hide-details>
					<v-radio style="height:48px" :label="$t('text.noBusinessHours')" :value="OPTION.NONE"></v-radio>
					<hr/>
					<v-radio style="height:48px" :label="$t('text.copyBusinessHours')" :value="OPTION.COPY" ></v-radio>
					<hr/>
					<v-radio style="height:48px" :label="$t('text.newBusinessHours')" :value="OPTION.NEW"></v-radio>
				</v-radio-group>
			</div>

			<div v-if="!showCopyOption"
				style="background: #eee; border-radius: 5px; padding: 10px; padding-right: 30px; margin: 10px 0; display: flex; gap: 10px;"
			>
				<div style="flex-grow: 1;">
					<p class="subTitle" v-html="businessHoursText" />
					<p v-html="businessHoursHelpText" />
				</div>
				<mys-switch
					v-model="haveBusinessHours"
					style="flex-shrink: 0;"
				/>
			</div>
		</div>

		<div v-if="copyOption == OPTION.NEW && (haveBusinessHours || showCopyOption)">
			<p class="subTitle" v-html="$t('text.regularHours')" />
			<fieldset style="border: none;">
				<template v-for="(timeSpan, ts) of localBusinessHours" :key="timeSpan?.sys?.id || ts">
					<div v-if="timeSpan && timeSpan.fields"
						class="timeSpan" :class="{ error: validationErrors[ts]?.length }"
					>
						<button class="removeRow" v-if="localBusinessHours.length > 1" @click="removeBusinessHours(ts, false)">
							<v-icon color="white">mdi-delete</v-icon>
						</button>
						<div style="border-radius: 5px; padding: 10px; display: flex; gap: 10px; align-items: center; font-weight: bold;">
							{{ formatDate(timeSpan.fields.validFromDate?.de) }} - {{ formatDate(timeSpan.fields.validToDate?.de) }}
							<button @click="edit(ts)"><v-icon>mdi-pencil</v-icon></button>
						</div>
						<BusinessHoursTimeTable v-if="timeSpan.fields.businessTimes" :timeSpan="timeSpan" style="margin-left: 10px;" />
						<div v-if="!timeSpan.fields.businessTimes" style="margin-left: 10px; padding: 10px; color: #999;">
							{{ $t('text.noBusinessTimesConfigured') }}
						</div>
						<div v-for="error, e of validationErrors[ts]" :key="e" class="error">
							{{ error.text }}
						</div>
					</div>
				</template>
				{{ selectedTimes }}
				<v-btn class="gradientButton" elevation="0" @click="addBusinessHours()" style="margin-bottom: 15px;"><v-icon>mdi-plus</v-icon> {{ $t('text.businessHoursAddTimespan') }}</v-btn><!-- {{ $t('text.addAnotherTimeFrame') }} -->
			</fieldset>
			<BusinessHoursCalendar :timeSpans="localBusinessHours" :exceptions="exceptions" />
		</div>

		<DataDialog ref="timespanDialog"
			class="timespanDialog"
			v-model="editingTimespan"
			:title="$t('text.businessHours')"
			width="800px"
			@update:modelValue="editComplete"
			:validator="model => !model || model.fields.validFromDate.de >= model.fields.validToDate.de ? $t('text.fromDateAfterToDateError') : null"
		>
			<template #content="{ model }">
				<div class="flex-sm-row" style="display: flex; gap: 60px; flex-direction: column;">
					<div style="display: flex; flex-direction: column; flex-grow: 1;">
						<div style="width: 100%;">{{ $t('text.dateFrom') }}</div>
						<IsoDatePicker2 v-if="model" v-model="model.fields.validFromDate.de" tz="Europe/Vienna" style="width: 100%; flex-grow: 1; justify-self: center;" />
					</div>
					<div style="display: flex; flex-direction: column; flex-grow: 1;">
						<div style="width: 100%;">{{ $t('text.dateTo') }}</div>
						<IsoDatePicker2 v-if="model" v-model="model.fields.validToDate.de" tz="Europe/Vienna" style="width: 100%; flex-grow: 1;" />
					</div>
				</div>
			</template>
		</DataDialog>
	</Disclosure>
</template>

<script>
// DESIGN: new design for business hours: https://overflow.io/s/X22BN13G/?node=d3fe2358
//         i see some usability problems with the designs, so i did not implement them

// TODO: prevent overlap (for now, actually JAMES should implement the overlap logic)
// TODO: copy exceptions into other timespans where they fit (plus have all in the first ts) 

// TODO: there are quite a few event interactions with the container - these should be removed,
//       "copy" should be fully handled here.

// TODO: binding: we should directly bind to the product model without DDE
// TODO: how can we support the change monitor that then sets the dirty flags in the requests?

// TODO: talk to Roni: is this gymnastics really necessary?
//       could we not just store all the exceptions into the first span?
//       talked to Bence + Roni: currently out-of-order exceptions and overlaps are unsupported in JAMES
//       Bence estimates 1-2d work to do this.
//       -> we will do a 2 phase plan
// PHASE 1:
// - we prevent overlaps
// - we will store all exceptions in the first timespan AND copy them to the "fitting" timespans
// TODO: validation: prevent timespan overlaps
// TODO: more validation?
// PHASE 2 (requires JAMES to support this):
// - we will store all exceptions in the first timespan ONLY
// - we will allow overlaps

import Common from '@/mixins/Common.vue'
import Disclosure from '@/components/common/Disclosure.vue'
import moment from 'moment'
import BusinessHoursCalendar from './BusinessHoursCalendar.vue'
import DataDialog from '../common/DataDialog.vue'
import IsoDatePicker2 from './IsoDatePicker2.vue'
import BusinessHoursTimeTable from './BusinessHoursTimeTable.vue'
import { DATE_FORMATS } from '@/constants'
import { BUSINESS_HOURS_OPTION, optionFromModel, optionChangeEvent } from './business-hours-option'

export default {
	name: 'BusinessHoursNew',
	mixins: [ Common ],
	emits: ['average-duration-changed', 'copy-business-hours', 'new-business-hours', 'no-business-hours', 'validity-changed'],
	components: { Disclosure, BusinessHoursCalendar, DataDialog, IsoDatePicker2, BusinessHoursTimeTable },
	props: {
		averageDurationOfStayInMinutes: Number,
		showCopyOption: Boolean,
		copyBusinessHours: Boolean,
		businessHours: Array,
		// TODO: use injection instead
		app: String,
		updateModel: Boolean,
		/** When true, section is locked because content is overwritten by MyCity importer. */
		contentManagedByMyCity: { type: Boolean, default: false },
	},
	data: () => ({
		copyOption: BUSINESS_HOURS_OPTION.COPY,
		selectedTimes: null,
		sectionMessage: {
			error: false,
			message: ''
		},
		haveBusinessHours: true,
		averageDurationOfStayInMinutesLocal: 0,
		// we handle exceptions globally, even though the data model has them inside timespans.
		exceptions: null,
		originalData: null,
		editingTimespan: null,
		editingTimespanIndex: null,
		// Local copy of businessHours to avoid prop mutation issues
		localBusinessHours: [],
		lastValidityResult: null,
		// the option setCopyOptionFromModel set: the watcher skips its emit once (AAL-86 Copilot)
		optionSetFromModel: null,
	}),
	computed: {
		OPTION: () => BUSINESS_HOURS_OPTION,
		businessHoursText() {
			if (this.app === 'BusinessProfile') return this.$t('text.haveBusinessHoursSP')
			else if (this.app === 'ServiceDetail') return this.$t('text.haveBusinessHoursService')
			return ''
		},
		businessHoursHelpText() {
			if (this.app === 'BusinessProfile') return this.$t('text.haveBusinessHoursSPHelp')
			if (this.app === 'ServiceDetail') return this.$t('text.haveBusinessHoursServiceHelp')
			return ''
		},
		validationErrors() {
			const r = {}
			if (!this.localBusinessHours) return r
			
			for (const [ts1, timeSpan1] of this.localBusinessHours.entries()) {
				r[ts1] = []
				// Check for overlap errors
				for (const [ts2, timeSpan2] of this.localBusinessHours.entries()) {
					if (!timeSpan1?.fields || !timeSpan2?.fields) continue
					if (timeSpan1 == timeSpan2) continue
					if (timeSpan1.fields.validFromDate.de > timeSpan2.fields.validToDate.de
						|| timeSpan1.fields.validToDate.de < timeSpan2.fields.validFromDate.de) continue
					r[ts1].push({ text: this.$t('text.businessHoursOverlapError'), field: 'validFromDate', otherObject: timeSpan2, otherIndex: ts2 })
					break
				}
				// Check if business hours are configured but no times are set for any day
				// Only validate when copyOption is 'NEW' (user chose to add new business hours)
				if (this.copyOption === BUSINESS_HOURS_OPTION.NEW && timeSpan1?.fields?.businessTimes?.de) {
					const businessTimes = timeSpan1.fields.businessTimes.de
					const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
					const hasAnyConfiguredTime = weekdays.some(day => {
						const dayTimes = businessTimes[day]?.times
						if (!dayTimes || dayTimes.length === 0) return false
						return dayTimes.some(time => time.openTime && time.openTime !== '')
					})
					if (!hasAnyConfiguredTime) {
						r[ts1].push({ text: this.$t('text.noBusinessTimesConfiguredError'), field: 'businessTimes' })
					}
				}
			}
			return r
		},
	},
	watch: {
		validationErrors: {
			handler(errors) {
				const hasErrors = Object.values(errors).some(e => e.length > 0)
				if (hasErrors) {
					const firstError = Object.values(errors).find(e => e.length > 0)[0]
					this.sectionMessage.error = true
					this.sectionMessage.message = firstError.text
				}
				else {
					this.sectionMessage.error = false
					this.sectionMessage.message = ''
				}
				const isValid = !hasErrors
				if (this.lastValidityResult !== isValid) {
					this.lastValidityResult = isValid
					this.$emit('validity-changed', isValid)
				}
			},
			deep: true,
			immediate: true
		},
		businessHours: {
			immediate: true,
			handler(newVal) {
				this.syncBusinessHoursFromProp(newVal)
			},
		},
		copyOption(v) {
			// the parent already holds the entity an option set from the model was derived from: no event then
			const event = optionChangeEvent(v, this.optionSetFromModel)
			this.optionSetFromModel = null
			if (!event) return
			// TODO (NEW): should we not rather just reset to the original data?
			this.$emit(event)
			if (event === 'no-business-hours') {
				// Clear local arrays
				this.localBusinessHours = []
				if (this.exceptions && Array.isArray(this.exceptions)) {
					while (this.exceptions.length) this.exceptions.pop()
				}
			}
		},
		exceptions: {
			deep: true,
			handler() {
				// add all exceptions to the first timeSpan
				if (!this.localBusinessHours || !this.localBusinessHours[0]) return
				// make sure, all timeSpans are wellformed
				for (const timeSpan of this.localBusinessHours) {
					// Add null check for timeSpan.fields
					if (!timeSpan || !timeSpan.fields) continue
					// ATT: we always reset the exceptions here. this also handles the NPE case
					timeSpan.fields.exceptions = { de: [] }
				}
				// TODO: group together same exceptions (same closed + same times, multiple dates)
				for (const exception of this.exceptions) {
					const ex = { dates: [ exception.date ], closed: exception.closed, times: exception.times }
					// find the right timeSpan and add the exception there
					let found = false
					for (const timeSpan of this.localBusinessHours) {
						// Add null checks
						if (!timeSpan || !timeSpan.fields) continue
						if (exception.date < timeSpan.fields.validFromDate.de
							|| exception.date > timeSpan.fields.validToDate.de) continue
						timeSpan.fields.exceptions.de.push(ex)
						found = true
					}
					// if we cant find the right one, we add it to the first one
					if (!found && this.localBusinessHours[0]?.fields) {
						this.localBusinessHours[0].fields.exceptions.de.push(ex)
					}
				}
			},
		},
	},
	methods: {
		syncBusinessHoursFromProp(businessHours) {
			// Sync local copy with prop changes and refresh the baseline used by sendData().changed.
			// Skip the sync when the parent echoes our own local changes back through the bound prop
			// (e.g. updateServiceProviderFromChildren writing businessHours back to serviceProvider.fields)
			// — if we reset originalData in that case, the second updateServiceProviderFromChildren call
			// in validate() would see isEqual() === true and produce changed=false, dropping the event.
			const validBH = businessHours ? businessHours.filter(bh => bh && bh.fields) : []
			if (this.originalData !== null && JSON.stringify(validBH) === JSON.stringify(this.localBusinessHours)) return
			this.localBusinessHours = JSON.parse(JSON.stringify(validBH))
			this.rebuildExceptionsAndBaseline()
		},
		rebuildExceptionsAndBaseline() {
			const defaultLocale = this.locales?.[0]?.code ?? 'de'
			const exceptions = {}

			for (const timespan of this.localBusinessHours ?? []) {
				if (!timespan?.fields) continue
				for (const exception of timespan.fields.exceptions?.[defaultLocale] ?? []) {
					for (const date of exception.dates ?? [exception.date]) {
						exceptions[date] = {
							date,
							closed: exception.closed,
							times: [ ...exception.times ],
						}
					}
				}
			}
			this.exceptions = Object.values(exceptions)

			this.originalData = JSON.parse(JSON.stringify(this.localBusinessHours))
			this.$nextTick(() => {
				this.originalData = JSON.parse(JSON.stringify(this.localBusinessHours))
			})
		},
		formatDate(date) {
			if (date !== "") {
				return moment(String(date.split("T")[0])).format(DATE_FORMATS.DATE)
			} else {
				return date
			}
		},
		addBusinessHours() {
			this.editingTimespanIndex = -1
			this.editingTimespan = this.getNewBusinessHours()
			this.$refs.timespanDialog.open()
		},
		edit(tsIndex) {
			this.editingTimespanIndex = tsIndex
			this.editingTimespan = this.localBusinessHours[tsIndex]
			this.$refs.timespanDialog.open()
		},
		// TODO: should we rather use a computed field with getter and setter?
		editComplete(timespan) {
			if (this.editingTimespanIndex >= 0) {
				this.localBusinessHours[this.editingTimespanIndex] = timespan
			}
			else {
				this.localBusinessHours.push(timespan)
			}
			this.editingTimespanIndex = null
			this.editingTimespan = null
		},
		removeBusinessHours(index, isException) {
			this.localBusinessHours.splice(index, 1)
		},
		getNewBusinessHours() {
			const counter = Math.random()

			let today = moment(new Date()).format('YYYY-MM-DD')
			let validToDate = moment(today).add(1, 'month').format('YYYY-MM-DD')

			return {
				sys: { id: 'id_bh_' + counter },
				fields: {
					validFromDate: { de: today },
					validToDate: { de: validToDate },
					isException: {de: false},
					businessTimes: {
						de: {
							monday:    { times: [{ openTime: '', closeTime: '' }] },
							tuesday:   { times: [{ openTime: '', closeTime: '' }] },
							wednesday: { times: [{ openTime: '', closeTime: '' }] },
							thursday:  { times: [{ openTime: '', closeTime: '' }] },
							friday:    { times: [{ openTime: '', closeTime: '' }] },
							saturday:  { times: [{ openTime: '', closeTime: '' }] },
							sunday:    { times: [{ openTime: '', closeTime: '' }] },
							holidays:  { times: [{ openTime: '', closeTime: '' }] },
						},
					},
				},
			}	
		},
		isEqual(a, b) {
			function normalize(t) {
				if (!t) return t
				// normalize trailing commas so we can use them as separators
				t = t.replace(/\}/g, ',}').replace(/\]/g, ',]')
				// iteratively do this, so whole structures are removed
				let t0
				do {
					t0 = t
					// remove empty array props "prop":[] and "prop":{} and "prop":null
					t = t.replace(/"[^"]":\[,*\],/g, ',')
					t = t.replace(/"[^"]":\{,*\},/g, ',')
					t = t.replace(/"[^"]":null,/g, ',')
				} while (t != t0)
				t = t.replace(/,/g, '')
				return t
			}
			a = normalize(JSON.stringify(a))
			b = normalize(JSON.stringify(b))
			return a == b
		},
		sendData() {
			// TODO: write back exceptions into timespans - or do this on change of exceptions?

			// Only filter out completely invalid entries (without fields property)
			// Don't filter based on whether times are configured - that's a validation concern, not a data concern
			const validBusinessHours = this.localBusinessHours?.filter(bh => {
				// Entry must have fields property
				return bh && bh.fields
			}) || []

			validBusinessHours.forEach(bh => {
				const org = this.originalData?.find(x => x?.sys?.id ===  bh?.sys?.id)
				if (!bh.fields?.exceptions?.de && org && org.fields?.exceptions?.de && !org.fields?.exceptions?.de?.length) {
					bh.fields.exceptions = { de: [] }
				}
			})
			
			return {
				businessHours: { de: validBusinessHours },
				changed: !this.isEqual(validBusinessHours, this.originalData),
			}
		},
		validateAllFields() {
			return Object.values(this.validationErrors).every(e => e.length == 0)
		},
		// AAL-86 Copilot: the radio follows the entity (copy on = COPY, own periods = NEW, none = NONE) without
		// the side effects of a user choice.
		setCopyOptionFromModel(copyBusinessHours, businessHours) {
			const option = optionFromModel(this.copyOption, copyBusinessHours, businessHours)
			if (!option) return
			this.optionSetFromModel = option
			this.copyOption = option
		},
	},
	mounted() {
		this.rebuildExceptionsAndBaseline()
		// TODO: on change of the calendar: distribute the exceptions back into the timespans
		//       should we group same (closed + times / JSON equal) exceptions into one exception object?

		const hasExistingBusinessHours = this.localBusinessHours?.length > 0 && this.localBusinessHours.some(bh => bh.sys?.id != '')
		this.copyOption = this.copyBusinessHours ? BUSINESS_HOURS_OPTION.COPY : hasExistingBusinessHours ? BUSINESS_HOURS_OPTION.NEW : BUSINESS_HOURS_OPTION.NONE
		if (this.app === 'BusinessProfile') this.copyOption = BUSINESS_HOURS_OPTION.NEW
		this.haveBusinessHours = this.localBusinessHours?.length > 0 ? true : false
		this.averageDurationOfStayInMinutesLocal = this.averageDurationOfStayInMinutes
	},
}
</script>

<style scoped>
hr { border: 1px solid #c0c0c0 !important; height: 1px; }
.v-text-field > .v-input__control > .v-input__slot::before { border-style: none !important;}
.v-text-field { padding-bottom: 12px !important; }
.timeSpan { position: relative; background: #f0f0f0; border-radius: 5px; margin-bottom: 10px; margin-top: 0; padding-bottom: 10px; }
.timeSpan.error { outline: 2px solid var(--error-color); }
.timeSpan .error { color: var(--error-color); margin-left: 10px; }
</style>

<style>
.timespanDialog .content { padding: 10px !important; }
.timespanDialog .content-wrapper { padding-top: 0; }
.timespanDialog .IsoDatePicker { box-shadow: none !important; margin: 0 !important; }
.timespanDialog .IsoDatePicker .v-date-picker-controls { padding: 0 !important; }
.timespanDialog .IsoDatePicker .v-date-picker-month { padding: 0 !important; }
</style>
